<picture>
  <source [srcset]="this.webp" type="image/webp">
  <source [srcset]="this.jpg" type="image/jpeg">
  <img [src]="this.jpg" [alt]="this.alt">
</picture>
